export default "__VITE_ASSET__wxRkGEoF__"